import Asset from "@components/CustomTypography/Asset/Asset"
import Content, {
	ContentType,
} from "@components/CustomTypography/Content/Content"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import {direction} from "@customTypes/customTypes"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import ButtonContainer from "../ButtonContainer/ButtonContainer"

import styles from "./ContentAsset.module.scss"

export type ContentAssetNewProps = {
	data?: AdvancedSideAssetMainContent
	direction?: direction
	contentProps?: ContentType
	imageClassName?: string
	withAutoSizing?: boolean
	shortDesc?: number
	withAspectRation?: boolean
	objectPosition?: "top" | "center" | "bottom"
	scale?: {
		width: 4 | 16
		height: 3 | 9
	}
}

const ContentAsset = (props: ContentAssetNewProps) => {
	if (typeof props.data === "undefined") {
		return <></>
	}

	const assetData = {...props.data.preview}

	return (
		<div
			className={`${styles.assetContainer}`}
			id={props.data.sectionid?.replace("#", "")}
		>
			<div className={styles.content}>
				<Content
					{...props.contentProps}
					containerClassName={styles.containerClassName}
					contentProps={{
						style: {
							paddingTop: props.data.title ? "2rem" : "0",
						},
						...props.contentProps?.contentProps,
					}}
					data={props.data}
					shortDesc={props.shortDesc}
				/>
				{props.data.buttons?.length != null &&
					props.data.buttons?.length > 0 && (
						<>
							<Separator size={32} />
							<ButtonContainer>
								<ButtonSwitcher buttonsList={props.data} />
							</ButtonContainer>
						</>
					)}
			</div>
			<div className={styles.asset}>
				<Asset
					data={{
						...assetData,
						imageClassName: styles.imageClassName,
						style: {
							aspectRatio: props.withAspectRation
								? "16/9"
								: "auto",
							objectPosition: props.objectPosition ?? "center",
						},
						alt: props?.data?.title ?? assetData?.alt,
					}}
					type={
						props.data.preview?.type
							? props.data.preview?.type
							: "string"
					}
				/>
			</div>
		</div>
	)
}

export default ContentAsset
